import NavBar from "../NavBar";

function ResultsDecision({
  completedCount,
  nextPersonNumber,
  onSeeResults,
  onAddPerson,
}) {
  return (
    <div className="min-h-screen bg-gray-50">
      <NavBar></NavBar>
      <div className="max-w-2xl mx-auto px-4 py-16">
        <div>
          <div className="px-8 py-16">
            {/* Checkmark */}
            <div className="flex justify-center mb-8">
              <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center shadow-lg">
                <svg
                  className="w-10 h-10 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.5}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
            </div>

            {/* Message */}
            <h2 className="text-3xl font-bold text-gray-900 mb-2 text-center">
              Person {completedCount} is finished!
            </h2>
            <p className="text-base text-gray-500 mb-10 text-center">
              {completedCount} people have completed the quiz
            </p>

            {/* Buttons */}
            <div className="space-y-3">
              <button
                onClick={onSeeResults}
                className="w-full bg-green-500 text-white py-4 rounded-lg text-lg font-semibold hover:bg-green-400 transition-colors shadow-sm"
              >
                See Results
              </button>
              <button
                onClick={onAddPerson}
                className="w-full bg-white text-gray-600 py-4 rounded-lg text-lg font-semibold border-2 border-gray-600 hover:border-gray-400 hover:text-gray-400 transition-colors"
              >
                Add Person {nextPersonNumber}
              </button>
            </div>

            {/* Privacy */}
            <div className="flex items-center justify-center gap-2 text-gray-500 text-sm pt-8 mt-8 border-t border-gray-200">
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                />
              </svg>
              <span>Private - Nothing saved</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResultsDecision;
